<template>
  <section class="success-deal">
    <div class="success-deal-container">
      <img :src="require(`@/assets/img/certificate-check.svg`)" />
      <h1 class="success-deal__title">Сделка успешно завершена!</h1>
    </div>
  </section>
</template>
<script>
export default {}
</script>
<style lang="scss">
.success-deal {
  height: 100%;
  width: 100vw;

  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 8px;

  &__title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 1.3rem;

    line-height: 100%;
    letter-spacing: 0%;

    color: #1f9e1b;

    margin: 0;
    padding: 0;
  }
}

.success-deal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;
}
</style>
